import React, { FC, ReactElement } from 'react';
import MainPage from './components/MainPage/MainPage';
import { MatchesProvider } from './context/context';

import '../scss/app.scss';

const App: FC = (): ReactElement => {
  return (
    <MatchesProvider>
      <MainPage />
    </MatchesProvider>
  );
};

export default App;
